<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 3">
      <el-breadcrumb separator=":">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>抽粪车作业量排行</el-breadcrumb-item>
        <div style="text-align: right"><el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">返回</el-button></div>

      </el-breadcrumb>
      <el-row class="margin-top-10">
        <el-col :span="2" class="margin-top-10">
          <label class="search-label">
            区域:
          </label>
        </el-col>
        <el-col :span="4" class="margin-top-10">
          <cascader :set-props="setProps"
                    :set-size="GLOBAL.config.systemSize" maxlength="64"
                    ref="myArea">
          </cascader>
        </el-col>
        <el-col :span="2"  style="text-align: right" class="margin-top-10">
          <label class="search-label">
            起止时间:
          </label>
        </el-col>
        <el-col :span="8" class="margin-top-10" style="text-align: left">
          <div class="block" style="width: 100%">
            <el-date-picker
              style="width: 48%"
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.beginTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择开始日期时间">
            </el-date-picker>
            <el-date-picker
              style="width: 48%"
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.endTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择结束日期时间">
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="2" class="margin-top-10">
          <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
          </el-button>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <el-button
            type="primary"
            @click="output"
            :size="GLOBAL.config.systemSize"
            icon="el-icon-upload2"
          >导出
          </el-button>
        </el-col>
      </el-row>
      <el-divider content-position="left" >图表信息</el-divider>
      <el-row style="margin-top: 20px">
        <el-col :span="18" >
          <barCharts  ref="barChart" @changeBarDate="changeBarDate"></barCharts>
        </el-col>
        <el-col :span="6" >
          <el-table style="width: 100%"
                    height="670px"
                    :data="tableData"
                    element-loading-text="数据处理中...请稍等..."
                    @cell-click="changeIndex"
                    v-loading="loading">
            <!--序号-->
            <el-table-column type="index" label="序号" width="80px" align="center"/>
            <!--车牌号-->
            <el-table-column prop="name" label="名称" align="center"/>
            <!--数量-->
            <el-table-column prop="pumpNum" label="数量" align="center"/>
          </el-table>
<!--                  <el-pagination-->
<!--                    class="margin-top-10 margin-bottom-20"-->
<!--                    @size-change="tableSizeChange"-->
<!--                    @current-change="currentChange"-->
<!--                    :current-page="pagination.currentPage"-->
<!--                    :page-sizes="pagination.pageSizeList"-->
<!--                    :page-size="pagination.pageSize"-->
<!--                    :layout="pagination.layout"-->
<!--                    :total="pagination.total">-->
<!--                  </el-pagination>-->
<!--                  <el-row class="margin-top-20">-->
<!--                    <el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>-->
<!--                    <el-button v-if="editableFlag" type="primary" @click="saveForm" style="margin: 0 20px;"-->
<!--                               :size="GLOBAL.config.systemSize">保存-->
<!--                    </el-button>-->
<!--                  </el-row>-->
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
    <!--      <router-view></router-view>-->
  </div>
</template>
<!--判断code属于哪一级-->
<!--如果是县级, 调用接口一 (不用传code, 后台默认处理)-->
<!--如果是乡镇级, 调用接口二 (需要传code)-->
<!--如果是村居, 调换列表页面-->
<script>
  import cascader from '../../../components/Cascader'
  import barCharts from './BarCharts'
  export default {
    name: 'analyzePh',
    data () {
      return {
          ssqhdm: JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm,
          values: '',
          loading: false,
          setProps: {
            multiple: false, // 单选
            checkStrictly: true, // 父节点取消选中关联
            value: 'code',
            label: 'name',
            children: 'children',
            leaf: 'leaf'
          },
          searchForm: {timeTwo: {beginTime: '', endTime: '', type: '2'}},
          tableData: [],
          // 层级
          index: '0',
          code: '',
          pickerOptions: {
              disabledDate(time) {
                  return time.getTime() > Date.now()
              }
          }
      }
    },
    created () {
      // this.init()
      // this.getCode()

    },
    mounted () {
      this.show()
    },
    watch: {
      tableData () {
        this.$refs.barChart.showInit(this.tableData)
      },
      $route (to, from) {
        let _this = this
        if (to.path === '/dataAnalysis/analyze') {
          setTimeout(function () {
            _this.$refs.barChart.showInit(_this.tableData)
            _this.$refs.myArea.init(_this.code)
          }, 100)
        }
      }
    },
    computed: {},
    methods: {
        output: function(){
            let _this=this
            let code = _this.$refs.myArea.sendToParent('value')
            if (!code) {
                code = this.ssqhdm
            }
            let flagNew = '1'
            if ((code && code == this.ssqhdm) || !code) {
                flagNew = '1'
            } else {
                flagNew = '2'
            }
            let info = {}
            let path = '/ReportForm'
            console.log(code.substring(code.length-2, code.length))
            if (code.substring(code.length-2, code.length) != '00') {
                info = {
                    current: 1,
                    size: 10000,
                    records: [
                        {
                            cmCode: code
                        }
                    ]
                }
                path = '/zyReportFormsq'
            } else {
                info = {
                    timeTwo: {
                        code :code?code:'',
                        beginTime: _this.searchForm.timeTwo.beginTime,
                        endTime: _this.searchForm.timeTwo.endTime,
                        type: '2',
                        flagNew: flagNew
                    }
                }
                path = '/ccReportForm'
            }
            // let  path='/ccReportForm'
            let name ="抽粪车作业量分析报表.xlsx"
            this.FUNCTIONS.systemFunction.postDownFileurl(this, {
                info: info,
                userInfo:{
                    user:JSON.parse(localStorage.getItem('gcUserInfo'))
                }
            },this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad +path,name)

        },
      // 初始化
      show(){
        const code = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
        this.code = code
        const num = this.showMeth1(code)
        if(num === 0){
          this.init()
        } else {
          this.biaogeChange(code)
        }
        this.$refs.myArea.init(code)
      },
      // 判断当前code是哪一级
      showMeth1(code){
        if(code%1000000 === 0){
          this.index = '0'
          return 0
        }
        if(code%100 === 0){
          this.index = '1'
          return 1
        }
          this.index = '2'
          return 2
      },
      init () {
        let _this = this
        _this.loading = true
        let searchParams = this.searchForm
        searchParams.baseService = 'TGcBxxxServiceImpl'
        // 3、 调接口获取数据
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
          _this.GLOBAL.config.handleType.getVillages, // 业务模块类型
          searchParams, //
          null,
          resultData => {
            setTimeout(function () {
              _this.loading = false
            }, 200)
            if (resultData) {
              if (resultData.code === '200') {
                _this.tableData = resultData.obj
                this.index = '1'
              }
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      // 表格跳转还是本地跳转
      biaogeChange (code) {
        this.showMeth1(code)
        let _this = this
        if (this.index === '1') {
          let info = {
            code: code,
            type: '2',
            baseService: 'TGcBxxxServiceImpl',
            beginTime: _this.searchForm.timeTwo.beginTime,
            endTime: _this.searchForm.timeTwo.endTime}
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
            _this.GLOBAL.config.handleType.getVillagesCommittee, // 业务模块类型
            info, //
            null,
            resultData => {
              _this.loading = false
              if (resultData) {
                if (resultData.code === '200') {
                  _this.tableData = resultData.obj
                }
              } else {
                _this.$message.warning('获取列表数据失败～')
              }
            },
            () => {
              _this.loading = false
            }
          )
        } else {
          this.$router.push({
            name: 'analyzeTable',
            params: {
              code: code,
              beginTime:_this.searchForm.timeTwo.beginTime,
              endTime: _this.searchForm.timeTwo.endTime

            }
          })
        }
      },
      // 子向父传参, 触发图形调用的方法 data = 图形X的名称
      changeBarDate (data) {
        if (data === '平均值' || data === '最大值' || data === '最小值') {
          return
        }
        let _this = this
        let code = this.getCodeByName(data)

        _this.biaogeChange(code)
      },
      // 根据name获取code
      getCodeByName (data) {
        let code = ''
        for (const e in this.tableData) {
          if (this.tableData[e].name === data) {
            code = this.tableData[e].code
            return code
          }
        }
      },
      // 右侧表格点击事件
      changeIndex (data) {
        if (this.index === '0') {
          this.init()
        } else {
          this.biaogeChange(data.code)
        }
      },
      // 查询
      doSearch () {
        let _this = this
        if (this.searchForm.timeTwo.beginTime && this.searchForm.timeTwo.endTime) {
            if (!_this.FUNCTIONS.systemFunction.compareDate(this.searchForm.timeTwo.beginTime, this.searchForm.timeTwo.endTime)) {
                this.$message.warning('开始日期不能大于结束日期！')
                return
            }
        }
        let code = _this.$refs.myArea.sendToParent('value')
        // if (this.code === null || this.code === '') {
        //   this.show()
        // }
        if (code === '340122000000' || code === null) {
          this.init()
          return
        }
        const num = _this.showMeth1(code)
        if (num === 2) {
          this.biaogeChange(code)
        } else {
          this.code = code
          let info = {code: code, type: '2', beginTime: _this.searchForm.timeTwo.beginTime, endTime: _this.searchForm.timeTwo.endTime, baseService: 'TGcBxxxServiceImpl'}
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
            _this.GLOBAL.config.handleType.getVillagesGather, // 业务模块类型
            info, //
            null,
            resultData => {
              _this.loading = false
              if (resultData) {
                if (resultData.code === '200') {
                  _this.tableData = resultData.obj.slice(1)
                  let num = _this.showMeth1(code)
                  if(num === 0){
                    _this.index = 0
                  }
                  if(num === 1){
                    _this.index = 2
                  }
                }
              } else {
                _this.$message.warning('获取列表数据失败～')
              }
            },
            () => {
              _this.loading = false
            }
          )
        }
      },
      goBack: function () {
        let _this = this
        if (this.index === '0' || this.index === '1') {
          _this.index = '0'
          this.$router.go(-1)
        } else {
          _this.init()
          _this.index = '0'
        }
      },
    },
    components: {
      cascader,
      barCharts
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/system/analyze/analyzePh.vue